import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMutualSkillsAction } from "../../redux/actions/userActions";
import CommonLoading from "../loader/CommonLoading";

const MutualSkillsCard = ({ userId }) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth?.userData);
  const mutualSkills = useSelector((state) => state.user?.mutualSkills);
  const mutualSkillsLoading = useSelector((state) => state.user?.mutualSkillsLoading);

  // Only fetch mutual skills if user is logged in
  useEffect(() => {
    if (userId && userData) {
      dispatch(getMutualSkillsAction(userId));
    }
  }, [dispatch, userId, userData]);

  // Don't show mutual skills if user is not logged in
  if (!userData) {
    return null;
  }

  if (mutualSkillsLoading) {
    return (
      <div className="bg-white rounded-lg border p-3 md:p-4 shadow-sm">
        <h5 className="mb-3 text-sm font-semibold font-roboto-flex">Mutual Skills</h5>
        <div className="flex justify-center items-center py-4">
          <CommonLoading />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border p-3 md:p-4 shadow-sm">
      <h5 className="mb-3 text-sm font-semibold font-roboto-flex">Mutual Skills</h5>
      
      {mutualSkills?.length === 0 ? (
        <div className="text-center text-gray-400 font-roboto-flex py-2 md:py-3 text-xs md:text-sm">
          No mutual skills found
        </div>
      ) : (
        <div className="flex flex-wrap gap-2">
          {mutualSkills?.map((skill, index) => (
            <span
              key={index}
              className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 font-roboto-flex"
            >
              {skill.name}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default MutualSkillsCard;
